import readCookie from './cookie';

const hasBadgeClass = 'has--badge';
const dataBadgeWishlistSelector = '[data-badge-wishlist]';
const wishlistCounterCookieName = 'obo_noticelist_counter';

/**
 * @return {Number} Number of wishlist items
 */
function getNumberOfItemsOnWishlist() {
  return readCookie(wishlistCounterCookieName);
}

/**
 * @return {void}
 */
function showWishlistBadge() {
  const wishlistBadge = document.querySelector(dataBadgeWishlistSelector);

  wishlistBadge.classList.add(hasBadgeClass);
}

/**
 * @return {void}
 */
function hideWishlistBadge() {
  document.querySelector(dataBadgeWishlistSelector).classList.remove(hasBadgeClass);
}

/**
 * @param  {Number} quantity number of items on wishlist
 * @return {void}
 */
function updateWishlistBadge(quantity) {
  const wishlistBadge = document.querySelector(dataBadgeWishlistSelector);
  const count = quantity !== undefined ? quantity : getNumberOfItemsOnWishlist();

  // check if badge exists
  if (wishlistBadge === null) return;

  if (count <= 0) {
    hideWishlistBadge();

    // reset
    document.querySelector(dataBadgeWishlistSelector).setAttribute('data-badge-wishlist', '');
  } else {
    wishlistBadge.setAttribute('data-badge-wishlist', count);
    showWishlistBadge();
  }
}

export {
  updateWishlistBadge,
  getNumberOfItemsOnWishlist,
};




// WEBPACK FOOTER //
// ./assets/js/components/wishlist-actions.js